import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'db-product-page-type-tooltip',
    templateUrl: './product-page-type-tooltip.component.html',
    styleUrl: './product-page-type-tooltip.component.scss',
    standalone: false
})
export class ProductPageTypeTooltipComponent {
  @Output() generate: EventEmitter<string> = new EventEmitter<string>();
  @Input() newPageType: string;
  selectedType = '';
}
